import { render, staticRenderFns } from "./membership-category-single.vue?vue&type=template&id=5d968000&"
import script from "./membership-category-single.vue?vue&type=script&lang=ts&"
export * from "./membership-category-single.vue?vue&type=script&lang=ts&"
import style0 from "./membership-category-single.vue?vue&type=style&index=0&lang=scss&_scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports